<template>
<div v-if="promocodesEnabled" class="mb-4">
  <div v-if="!hasPromocode" class="flex flex-row items-end gap-x-4">
    <CustomField class="flex-1">
      <CustomInput label="Если у вас есть промокод, введите его здесь."
                   type="text"
                   placeholder="Промокод"
                   v-model="promocode"
      />
    </CustomField>
    <button class="btn btn-primary btn-sm btn-rounded" :disabled="!promocode || isApplying" @click="setPromocode">
      Применить
    </button>
  </div>
  <div v-else>
    <div class="p-4 rounded bg-primary-lighter text-primary-darker">
      <p class="text-sm">{{ order.promocode.message }}</p>
      <p class="text-xs mt-4">
        <a href="javascript:;" @click="removePromocode" class="underline text-primary-darkest">Удалить промокод</a>
      </p>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CustomField from '@/components/inputs/CustomField.vue';
import CustomInput from '@/components/inputs/CustomInput.vue';

export default {
  components: {
    CustomInput,
    CustomField,
  },

  computed: {
    ...mapGetters({
      order: 'order/order',
      orderOptions: 'store/orderOptions',
    }),

    promocodesEnabled() {
      if (!Array.isArray(this.orderOptions)) {
        return false;
      }

      return this.orderOptions.indexOf('promocode') !== -1;
    },

    hasPromocode() {
      return this.order && this.order.promocode !== null;
    },
  },

  methods: {
    ...mapActions({
      applyPromocode: 'order/applyPromocode',
      cancelPromocode: 'order/cancelPromocode',
    }),

    async setPromocode() {
      if (this.isApplying) {
        return;
      }

      this.isApplying = true;

      await this.applyPromocode({
        promocode: this.promocode,
      });

      this.isApplying = false;
    },

    async removePromocode() {
      if (this.isApplying) {
        return;
      }

      this.isApplying = true;

      await this.cancelPromocode();

      this.isApplying = false;
      this.promocode = '';
    },
  },

  data() {
    return {
      isApplying: false,
      promocode: '',
    };
  },
}
</script>
